import React from "react";

function Cards({ title, content, bgColor, textColor }) {
  return (
    <div
      className={`relative rounded-lg w-full min-h-[8rem] sm:min-h-[10rem] md:min-h-[12rem] lg:min-h-[14rem] border-gray-300 shadow-xl ${bgColor} flex flex-col items-center justify-center p-4`}
    >
      <h3
        className={`text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold ${textColor}`}
      >
        {content}
      </h3>
      <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-bold text-center">
        {title}
      </p>
    </div>
  );
}

export default Cards;
